import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import RightArrow from "../Assets/icons/right-arrow.svg";
import image4 from "../Assets/images/s1.png";
import image5 from "../Assets/images/s2.png";
import image6 from "../Assets/images/s3.png";
import "../Style/Service.scss";

const Service = () => {
  const [number, setNumber] = useState(1);
  console.log(number);
  return (
    <div className="service-page">
      <Container>
        <Row className="section_row">
          <Col className="col-md-12">
            <div className="section_title">
              <h2>SERVICES</h2>
            </div>
          </Col>
        </Row>
        <Row className="service_content_row">
          <Col className="col-md-5">
            {tabMenu.map((d, i) => (
              <div
                key={i + 1}
                className={`button ${number === i + 1 ? "isActive" : ""}`}
                onClick={() => setNumber(i + 1)}
              >
                {d}
              </div>
            ))}
          </Col>
          <Col className="col-md-5">
            {number === 1 && (
              <div className="tab_content">
                <p>
                  JavaScript - HTML 5 - CSS 3 - jQuery - Vue - React - PHP -
                  MySQL
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Website development
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Corporate website
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Startup websites
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Landings and promo sites
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    E-commerce
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Web applications development
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Wordpress development
                  </span>
                  <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
            {number === 2 && (
              <div className="tab_content">
                <p>
                Photoshop - Illustrator - Sketch - Creative Suite - Axure - Adobe XD - Figma
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Web design
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Mobile app design
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    UX, UI design
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Logo design
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Brand Identity
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Web applications development
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Banner ad design
                  </span>
                  <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
            {number === 3 && (
              <div className="tab_content">
                <p>
                PHP - Node.js - Bootstrap - AngularJS - WordPress - Figma - Axure RP - Slack - Skype
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Dedicated team
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Hire Back-End Developer
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Hire Front-End Developer
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Hire Designer
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                   Hire Project manager
                  </span>
                 <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
            {number === 4 && (
              <div className="tab_content">
                <p>
                Value Proposition Canvas - Google Ads - Facebook Ad - Social Media
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Conversion marketing
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Content marketing
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    PPC services
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Social media marketing services
                    </span>
                  <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
            {number === 5 && (
              <div className="tab_content">
                <p>
                Webmaster tools - Google Analytics - Ahrefs - Serpstat
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Tech SEO
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    On-page SEO
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Off-page SEO
                  </span>
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    SEO copywriting
                  </span>
                  <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
            {number === 6 && (
              <div className="tab_content">
                <p>
                WordPress - Woocommerce PHP - AngularJS - Sketch - Figma - Axure RP
                </p>
                <div className="tab_text">
                  <span>
                    <img src={RightArrow} alt="arrow" />
                    Fixed price website
                  </span>
                 <button className="btn2">READ MORE</button>
                </div>
              </div>
            )}
          </Col>
        </Row>
        <div className="parent">
          <img className="image4 bounce-3" src={image4} alt="" />
          <img className="image5 bounce-3" src={image5} alt="" />
          <img className="image6 bounce-3" src={image6} alt="" />
        </div>
      </Container>
    </div>
  );
};

export default Service;

const tabMenu = [
  "WEB DEVELOPMENT SERVICES",
  "DESIGN SERVICES",
  "OUTSOURCE",
  "DIGITAL MARKETING",
  "SEO SERVICES",
  "BUSINESS PACKAGES",
];
